
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-think.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-think-demo-think"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-think.en-US.md?type=demo')
};